import { captureException } from '@sentry/browser';

/**
 * Convert html text to javascript element object
 *
 * @param htmlText <div>Hello clover</div>
 */
export function htmlToElement(htmlText: string): Element | null {
    if (!htmlText) return null;

    const template: HTMLTemplateElement = document.createElement('template');
    htmlText = htmlText.trim();
    template.innerHTML = htmlText;
    return template.content.firstElementChild;
}

export function getHrefLangData(hrefLangTags: string | undefined): undefined | {hreflang: string; rel: string; href: string} {
    if (!hrefLangTags) return;
    const ele: Element | null = htmlToElement(hrefLangTags);
    if (!ele || ! (ele instanceof HTMLLinkElement)) {
        captureException(new Error(`HREF Lang tags defined in contentful are invalid ${hrefLangTags}`));
        return;
    }
    const linkTag: HTMLLinkElement = ele;
    return {
        hreflang: linkTag.hreflang,
        rel: linkTag.rel,
        href: linkTag.href,
    };
}
